import axiosHelper from '../utils/axios';

export default (() => {
  const networkAssetPath = '/networkAsset';

  async function requestWithFallback({ method, url, data }) {
    try {
      const response = await axiosHelper.getNetworkAsset()({
        method,
        url: `${networkAssetPath}${url}`,
        data,
      });
      return response.data;
    } catch (e) {
      const status = e && (e.status || e.response?.status);
      if (status === 404 || status === 405) {
        const response = await axiosHelper.getAccess()({ method, url, data });
        return response.data;
      }
      throw e;
    }
  }

  async function getMePreferences() {
    return requestWithFallback({ method: 'get', url: '/me/preferences' });
  }

  async function updateDefaultMapView(payload) {
    return requestWithFallback({
      method: 'put',
      url: '/me/preferences/default-map-view',
      data: payload,
    });
  }

  async function updateDefaultHomePage(payload) {
    return requestWithFallback({
      method: 'put',
      url: '/me/preferences/default-home-page',
      data: payload,
    });
  }

  async function deleteDefaultMapView() {
    return requestWithFallback({
      method: 'delete',
      url: '/me/preferences/default-map-view',
    });
  }

  return {
    getMePreferences,
    updateDefaultMapView,
    updateDefaultHomePage,
    deleteDefaultMapView,
  };
})();
